import { createContext } from "react";

import { TLocaleContext } from "./types";

const LocaleContext = createContext<TLocaleContext>(undefined);

export default LocaleContext;
